module.exports = __webpack_public_path__ + "img/375.a36b21a8.jpg";